/* eslint-disable */
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import './EscapeTeamForm.css';

import {
  upload,
} from '../../actions';


class MemberForm extends OzFormComponent {
  static fields = [
    'name',
    'email',
  ]

  renderBody() {
    return (
      <div className="MemberForm">
        {this.renderFormGroup(null, 'text', 'name', { placeholder: 'Team member name' })}
        {this.renderFormGroup(null, 'email', 'email', { placeholder: 'Email' })}
      </div>
    );
  }
}


class EscapeTeamForm extends OzFormComponent {

  static fields = [
    'members',
    'name',
    'photo',
  ]

  options = {
    members: {
      init: {
        email: '',
        name: '',
      }
    },
  }

  constructor(props) {
    super(props);
    this.state = {
      // members: [{ email: '', name: '' }],
    }
  }

  componentDidMount() {
    this.addMany('members');
    // this.addMany('members');
    // this.addMany('members');
    // this.addMany('members');
  }

  getValues() {
    let values = super.getValues();
    values.escapeId = this.props.escape.id;
    return values;
  }

  addNewMember(values) {
    console.log('addNewMember', values);
  }

  renderMembers() {
    let members = this.state.members || [];
    let i = 0;
    let nodes = members.map(member => {
      let index = i;
      i++;
      return (
        <MemberForm
          key={member.id}
          index={member.id}
          errors={this.props.errors ? this.props.errors.members[index] : null}
          part={true}
          values={member}
          cancelRender={() => <Glyphicon className="minus-sign" glyph="minus-sign" />}
          onCancel={() => this.removeMany(member.id, 'members')}
          onChange={(values) => this.updateMany(member.id, values, 'members')}
        />
      );
    });

    return (
      <div className="members-wrapper">
        {nodes}
        <div className="add-member">
          <Button onClick={() => this.addMany('members')}>Add Team Member</Button>
        </div>
      </div>
    );
  }

  pickTeam(team) {
    let members = [];
    for (let member of team.members) {
      members.push({ email: member.email, name: member.username });
    }
    this.setState({ members });
  }

  renderPickTeams() {
    let teams = this.props.teams;
    if (!teams || teams.length == 0) return;

    let nodes = teams.map(team => {
      return (
        <div className="team-choice" onClick={() => this.pickTeam(team)}>
          {team.name}
        </div>
      )
    });

    return (
      <div className="team-choices">
        {nodes}
      </div>
    );
  }

  renderBody() {
    let escape = this.props.escape;
    console.log('team form for', escape);
    return (
      <div className="EscapeTeamForm">
        <p>Add a team for your escape from <b>{escape.room.name}</b></p>
        {this.renderPickTeams()}
        {this.renderFormGroup('What is the team name? (optional)', 'text', 'name')}
        {/*this.renderFormGroup('Team photo (optional)', 'image', 'photo')*/}
        {this.renderMembers()}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    upload: (...args) => dispatch(upload(...args)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EscapeTeamForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/EscapeTeamForm.js
 **/